import DonationAmountMonthly from './DonationAmountMonthly';

export default DonationAmountMonthly;
